import * as z from "zod";

export const getSupportV2ConversationCounts = {
  name: "getSupportV2ConversationCounts" as const,
  input: z.object({}),
  output: z.object({
    mongoConversationCount: z.number(),
    crdbSupportTicketCount: z.number(),
  }),
};
export type SupportV2ConversationCounts = z.infer<
  typeof getSupportV2ConversationCounts.output
>;
